import { getTenantSlugFromHost } from '@/shared/lib/tenant-host'

const DEFAULT_DEV_API_ORIGIN = 'http://localhost:8000'

type ApiEnv = {
  DEV?: boolean
  VITE_API_URL?: string
}

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '')
}

export function resolveApiOrigin(env: ApiEnv = import.meta.env): string {
  // Branded consumer hosts must go through the same-origin Vite proxy even
  // when VITE_API_URL is set. Direct :8000 calls drop the browser Host, so
  // the backend never sees the tenant and another company's product can
  // still be registered.
  if (env.DEV && typeof window !== 'undefined' && getTenantSlugFromHost()) {
    return ''
  }

  const configuredOrigin = env.VITE_API_URL?.trim()
  if (configuredOrigin) {
    return stripTrailingSlash(configuredOrigin)
  }

  if (env.DEV) {
    return DEFAULT_DEV_API_ORIGIN
  }

  return ''
}

export function buildApiUrl(path: string, env: ApiEnv = import.meta.env): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${resolveApiOrigin(env)}${normalizedPath}`
}
